export const AXIOS_CONSTANTS = {
  TIMEOUT: 30000,
};
